/**
 * Lookup tables for geo + language targeting on Google Ads campaigns.
 *
 * Extracted from `NetworkSettingsStep.tsx` so the Step file only exports
 * components (satisfies `react-refresh/only-export-components`). The Vite
 * Fast Refresh integration falls back to a full reload when a file
 * exports both components and runtime values; isolating these constants
 * here keeps `NetworkSettingsStep.tsx` and the consumer steps
 * (`DemandGenSettingsStep`, `ReviewStep`) hot-reloadable.
 *
 * IDs come from Google's GeoTargetConstant + LanguageConstant catalogues —
 * unchanged from when they lived inline in NetworkSettingsStep.
 */

// Common geo targets with their Google Ads GeoTargetConstant IDs
export const GEO_TARGET_OPTIONS = [
  { id: 2840, name: 'United States', code: 'US' },
  { id: 2826, name: 'United Kingdom', code: 'GB' },
  { id: 2124, name: 'Canada', code: 'CA' },
  { id: 2036, name: 'Australia', code: 'AU' },
  { id: 2276, name: 'Germany', code: 'DE' },
  { id: 2250, name: 'France', code: 'FR' },
  { id: 2724, name: 'Spain', code: 'ES' },
  { id: 2380, name: 'Italy', code: 'IT' },
  { id: 2528, name: 'Netherlands', code: 'NL' },
  { id: 2056, name: 'Belgium', code: 'BE' },
  { id: 2756, name: 'Switzerland', code: 'CH' },
  { id: 2040, name: 'Austria', code: 'AT' },
  { id: 2372, name: 'Ireland', code: 'IE' },
  { id: 2554, name: 'New Zealand', code: 'NZ' },
  { id: 2392, name: 'Japan', code: 'JP' },
  { id: 2484, name: 'Mexico', code: 'MX' },
  { id: 2076, name: 'Brazil', code: 'BR' },
  { id: 2356, name: 'India', code: 'IN' },
];

// Common languages with their Google Ads LanguageConstant IDs
export const LANGUAGE_OPTIONS = [
  { id: 1000, name: 'English' },
  { id: 1001, name: 'German' },
  { id: 1002, name: 'French' },
  { id: 1003, name: 'Spanish' },
  { id: 1004, name: 'Italian' },
  { id: 1005, name: 'Portuguese' },
  { id: 1009, name: 'Dutch' },
  { id: 1014, name: 'Chinese (Simplified)' },
  { id: 1017, name: 'Japanese' },
  { id: 1012, name: 'Korean' },
  { id: 1019, name: 'Arabic' },
  { id: 1020, name: 'Hindi' },
];
